export default __webpack_public_path__ + "static/media/Gam of Four Trigrams.d2ba067f.png";